export default __webpack_public_path__ + "static/media/elonList.52ab67a6.png";